<template>
<div>
    <MenuPos />
    <!-- <div class="d-flex justify-space-between mb-2">
        <div class="d-flex justify-center align-center">
            <div class="img_title_order_list">
                <img src="@/assets/chef.png">
            </div>
            <h2 class="title_order_list">ออเดอร์วันนี้</h2>
        </div>
        <v-btn color="success" height="50" width="20%" @click="$router.push('/restaurant')">
            ย้อนกลับ
        </v-btn>
    </div> -->
    <v-slide-x-reverse-transition>
        <v-alert type="warning" class="alert_success" v-if="alert_waiting === true">กำลังทำการพิมพ์ออเดอร์กรุณารอสักครู่...</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div>
            <v-row>
                <v-col cols="12">
                    <div class="d-flex mb-2">
                        <div class="d-flex align-center">
                            <div class="mr-1 food_table_order_list"></div>
                            <div>ทานที่ร้าน</div>
                        </div>
                        <div class="d-flex align-center ml-4 mr-4">
                            <div class="mr-1 food_table_takehome_order_list"></div>
                            <div>ทานที่ร้าน + ซื้อกลับบ้าน</div>
                        </div>
                        <div class="d-flex align-center">
                            <div class="mr-1 food_takehome_order_list"></div>
                            <div>ซื้อกลับบ้าน</div>
                        </div>
                    </div>
                    <v-expansion-panels>
                        <v-expansion-panel class="mt-2 header_panel_order_list" v-for="(order_history_detail,key_history) in data" :key="key_history">
                            <v-expansion-panel-header class="color_font_history_order_list" v-if="order_history_detail.type == 'กินที่ร้าน' && order_history_detail.status_takehome == 0">
                                <div class="d-flex align-center">
                                    <div class="print_order_list mr-2" @click="printOrderDetail(order_history_detail)">
                                        <v-icon>mdi-printer</v-icon>
                                    </div>
                                    <div>
                                        Order # {{ order_history_detail.order }} {{ order_history_detail.table }} เวลา {{ order_history_detail.time }} น.
                                    </div>
                                    <div class="ml-3" v-if="setting_type_food.status_process_food == 1">
                                        <v-chip color="orange" link dark
                                            @click="changeStatusProcessFoodAll(order_history_detail.id, 1)"
                                            v-if="order_history_detail.count_unsuccess > 0">กดเพื่อเสิร์ฟทั้งหมด</v-chip>
                                        <v-chip v-else color="primary" dark>เสิร์ฟทั้งหมดแล้ว</v-chip>
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-header class="color_font_table_takehome_history_order_list" v-if="order_history_detail.type == 'กินที่ร้าน' && order_history_detail.status_takehome == 1">
                                <div class="d-flex align-center">
                                    <div class="print_order_list mr-2" @click="printOrderDetail(order_history_detail)">
                                        <v-icon>mdi-printer</v-icon>
                                    </div>
                                    <div>
                                        Order # {{ order_history_detail.order }} {{ order_history_detail.table }} เวลา {{ order_history_detail.time }} น.
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-header class="color_font_takehome_history_order_list" v-if="order_history_detail.type == 'กลับบ้าน'">
                                <div class="d-flex align-center">
                                    <div class="print_order_list mr-2" @click="printOrderDetail(order_history_detail)">
                                        <v-icon>mdi-printer</v-icon>
                                    </div>
                                    <div>
                                        Order # {{ order_history_detail.order }} {{ order_history_detail.table }} เวลา {{ order_history_detail.time }} น.
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="body_food_order_list">
                                <v-card color="blue lighten-5" class="pa-3 d-flex align-center mt-2" v-for="(history_detail,list_history_key) in order_history_detail.listDetaile" :key="list_history_key">
                                    <div class="d-flex align-center">
                                        <div class="mr-2 pa-3 amount_food_order_list">{{ history_detail.amount }}</div>
                                        <div>{{ history_detail.food }}
                                            <div class="topping_food_order_list">
                                                <ul>
                                                    <li v-for="(topping_name_list,key_topping) in history_detail.listTop" :key="key_topping">
                                                        <span v-if="topping_name_list.amount" class="amount_list_topping_order_list">{{ topping_name_list.amount }}</span> {{ topping_name_list.topingName }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="note_order_list" v-if="history_detail.description">
                                                หมายเหตุ : {{ history_detail.description }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex align-center ml-3" v-if="setting_type_food.status_process_food == 1">
                                        <v-chip color="orange" link dark
                                            @click="changeStatusProcessFood(history_detail.id, 1)"
                                            v-if="history_detail.status_process_food == 0">กดเพื่อเสิร์ฟ</v-chip>
                                        <v-chip color="success" dark
                                            v-if="history_detail.status_process_food == 1">เสิร์ฟแล้ว</v-chip>
                                    </div>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <div class="text-center mt-5" v-if="page != null">
                        <v-pagination v-model="page" :length="page_all" :total-visible="7" color="#55c0e9"></v-pagination>
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-dialog v-model="open_detail_order" persistent max-width="600">
            <div v-if="loading_page_detail_order === true">
                <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                    <v-skeleton-loader type="article, actions"></v-skeleton-loader>
                </v-sheet>
            </div>
            <v-card v-if="loading_page_detail_order === false">
                <v-card-title>
                    ยืนยันการพิมพ์ออเดอร์
                </v-card-title>

                <v-card-text>
                    <div v-if="order_detail">
                        Order # {{ order_detail.order }} {{ order_detail.table }} เวลา {{ order_detail.time }} น.
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="printOrder()">
                        ตกลง
                    </v-btn>
                    <v-btn color="error" @click="closePrintOrder()">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import MenuPos from '@/components/menuadmin/MenuPos.vue'
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'orderList',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components: {
        MenuPos
    },
    data() {
        return {
            loading_page: true,
            data: [],
            setting_type_food: {},
            alert_waiting: false,
            alert_success: false,
            open_detail_order: false,
            loading_page_detail_order: true,
            order_detail: null,
            order_print_id: null,
            order_print_type: null,
            page: 1,
            page_all:1,
        }
    },
    methods: {
        async settingRestaurantDetail() {
            this.loading_page = true
            HTTP.get('/setup/restaurant', {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.setting_type_food = response.data.setup
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async orderList() {
            this.loading_page = true
            HTTP.get(`/order-all?page=${this.page}`, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.data = response.data.orderList
                        this.page = response.data.current_page ? parseFloat(response.data.current_page) : null
                        this.page_all = response.data.pages ? response.data.pages : 1
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async printOrderDetail(detail) {
            this.open_detail_order = true
            this.loading_page_detail_order = true
            this.order_detail = detail
            this.order_print_id = detail.id
            this.order_print_type = detail.type
            this.loading_page_detail_order = false
        },
        async closePrintOrder() {
            this.loading_page_detail_order = true
            this.order_detail = null
            this.order_print_id = null
            this.order_print_type = null
            this.open_detail_order = false
        },
        async printOrder() {
            this.loading_page_detail_order = true
            this.open_detail_order = false
            this.loading_page = true
            if (this.order_print_type == 'กินที่ร้าน') {
                HTTP.post('/order-status-update-print-again/' + this.order_print_id, null, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.orderList()
                            this.alert_waiting = true
                            setTimeout(() => this.alert_waiting = false, 5000)
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }
            if (this.order_print_type == 'กลับบ้าน') {
                HTTP.post('/ordertakehome-status-update-print-again/' + this.order_print_id, null, {
                        headers: {
                            "Authorization": `Bearer ${this.$store.state.token}`
                        }
                    })
                    .then((response) => {
                        if (response.data.successful === true) {
                            this.orderList()
                            this.alert_waiting = true
                            setTimeout(() => this.alert_waiting = false, 5000)
                        }

                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
            }

        },
        async changeStatusProcessFood(id, status) {
            HTTP.get('/update/status/food/order/detail/' + id + '?status=' + status, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        HTTP.get(`/order-all?page=${this.page}`, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                            .then((response) => {
                                if (response.data.successful === true) {
                                    this.data = response.data.orderList
                                    this.page = response.data.current_page ? parseFloat(response.data.current_page) : null
                                    this.page_all = response.data.pages ? response.data.pages : 1
                                }

                            }).catch((error) => {
                                if (error.response.status === 401) {
                                    this.$store.commit('logOutSuccess')
                                    this.$router.push('/login')
                                }
                            })
                        this.alert_success = true
                        setTimeout(() => this.alert_success = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async changeStatusProcessFoodAll(id, status) {
            HTTP.get('/update/status/food/order/' + id + '?status=' + status, {
                headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                }
            })
                .then((response) => {
                    if (response.data.successful === true) {
                        HTTP.get(`/order-all?page=${this.page}`, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                            .then((response) => {
                                if (response.data.successful === true) {
                                    this.data = response.data.orderList
                                    this.page = response.data.current_page ? parseFloat(response.data.current_page) : null
                                    this.page_all = response.data.pages ? response.data.pages : 1
                                }

                            }).catch((error) => {
                                if (error.response.status === 401) {
                                    this.$store.commit('logOutSuccess')
                                    this.$router.push('/login')
                                }
                            })
                        this.alert_success = true
                        setTimeout(() => this.alert_success = false, 5000)
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        }
    },
    mounted() {
        this.orderList()
        this.settingRestaurantDetail()
    },
    watch:{
        page(){
            this.orderList()
        }
    }
}
</script>
